import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fixed',
  standalone: true,
})
export class FixedPipe implements PipeTransform {
  transform(number: number): string {
    return number.toFixed(2);
  }
}
